<template>
	<div class="hris-page">
		<div class="hris-page-inner">
			<div class="hris-page-header hris-page-header-row">
				<div>
					<span class="hris-page-eyebrow">Timekeeping</span>
					<h1 class="hris-page-title">Binary Schedule</h1>
					<p class="hris-page-subtitle">Set employee schedules and manage binary device uploads.</p>
				</div>
				<div class="row q-gutter-sm">
					<q-btn unelevated class="hris-q-outline" label="Download Template" @click="getTemplate()"></q-btn>
					<q-btn unelevated class="hris-q-primary" label="Upload Binary" @click="importEmployees"></q-btn>
				</div>
			</div>

			<div class="hris-toolbar">
				<q-select v-model="month" :options="monthOptions" label="Month" emit-value map-options option-value="id" option-label="name" outlined dense color="green" style="min-width: 160px; max-width: 200px;"></q-select>
				<q-select v-model="cutoff" :options="cutoffOptions" label="Cut-off" emit-value map-options option-value="id" option-label="name" outlined dense color="green" style="min-width: 160px; max-width: 200px;"></q-select>
				<q-select v-model="department" :options="departments" option-value="id" option-label="name" label="Department" outlined dense color="green" style="min-width: 160px; max-width: 200px;"></q-select>
				<q-btn unelevated class="hris-q-primary" label="Filter" @click="filterByDate"></q-btn>
			</div>

			<div class="hris-panel">
				<div class="hris-panel-title">Set Schedule</div>
				<q-table
					:dense="$q.screen.lt.md"
					:columns="rangeHeader"
					:data="schdules"
					row-key="id"
					:separator="separator"
					:pagination.sync="pagination"
					flat
				>
					<template v-slot:header="props">
						<q-tr :props="props">
							<q-th v-for="col in props.cols" :key="col.name" :props="props">
								{{ col.label }}
							</q-th>
						</q-tr>
					</template>
					<template v-slot:body="props">
						<q-tr slot="body" :props="props" style="cursor: pointer;">
							<q-td class="text-center">{{ props.row.employee_id }}</q-td>
							<q-td class="text-center">{{ props.row.name }}</q-td>
							<q-td v-for="sched in props.row.schedule" :key="sched.id" class="text-center caps">
								{{ sched.type }}
							</q-td>
						</q-tr>
					</template>
					<template v-slot:no-data="">
						<div class="hris-empty full-width">No result found.</div>
					</template>
					<template v-slot:top="props">
						<q-input dense outlined color="green" v-model="searchKey" placeholder="Search Employee" class="caps">
							<template v-slot:append>
								<q-icon name="fas fa-search"></q-icon>
							</template>
						</q-input>
						<q-space></q-space>
						<q-btn unelevated class="hris-q-outline" label="Download" no-caps></q-btn>
					</template>
				</q-table>
			</div>

			<q-dialog v-model="importfile" persistent transition-show="fade" transition-hide="fade">
				<div class="hris-modal" style="max-width: 420px;">
					<q-form ref="form" autocomplete="off" @submit="onSubmit">
						<div class="hris-modal-header">
							<div>
								<h2 class="hris-modal-title">Select File</h2>
								<p class="hris-modal-subtitle">(.csv Only)</p>
							</div>
						</div>
						<div class="hris-modal-body">
							<input type="file" id="file" ref="file" accept=".csv" :rules="[ val => val && val.length > 0 || 'This field is required!']"  v-on:change="handleFileUpload()"/>
						</div>
						<div class="hris-modal-footer">
							<q-btn unelevated class="hris-q-ghost" label="Close" @click="closeModal"></q-btn>
							<q-btn unelevated class="hris-q-primary" label="Submit" type="submit"></q-btn>
						</div>
					</q-form>
				</div>
			</q-dialog>

			<q-dialog v-model="spinner" persistent>
				<div class="hris-loading" style="background: transparent; min-width: 200px;">
					<q-spinner color="green" size="3em"></q-spinner>
				</div>
			</q-dialog>
		</div>
	</div>
</template>

<script>
import axios from 'axios';
import mixins from '../../mixins';
export default {
	data () {
		return {
            searchKey:'',
            rangeHeader:[],
            schdules:[],
            departments: [],
            department:{'id':0,'name':'ALL'},
			separator:'cell',
			fromDay: new Date().toISOString().slice(0, 10).replace("-", "/").replace("-", "/"),
			toDay: new Date().toISOString().slice(0, 10).replace("-", "/").replace("-", "/"),
			importfile:false,
			spinner:false,
			file:'',
			pagination: {
				rowsPerPage: 30
			},
			month:new Date().getMonth() + 1,
			cutoff: new Date().getDate() > 10 && new Date().getDate() < 26 ? 2 : 1,
			cutoffOptions:[{id:1,name:'First Cut-off'},{id:2,name:'Second Cut-off'}],
			monthOptions:[
			{id:1,name:'January'},
			{id:2,name:'February'},
			{id:3,name:'March'},
			{id:4,name:'April'},
			{id:5,name:'May'},
			{id:6,name:'June'},
			{id:7,name:'July'},
			{id:8,name:'August'},
			{id:9,name:'September'},
			{id:10,name:'October'},
			{id:11,name:'November'},
			{id:12,name:'December'},],
		}
	},
	created(){
		this.displaySchedule()
        this.getDropdownProperties()
	},
	methods: {
		importEmployees:function(){
			this.importfile = true
		},
		closeModal:function(){
			this.importfile = false
		},
		onSubmit:function(){
			this.spinner = true
			let formData  = new FormData();
			formData.append("files", this.file);
			axios({
				onUploadProgress: uploadEvent => {
					console.log("Progress: " + Math.round(uploadEvent.loaded / uploadEvent.total * 100) + '%')
				},
				headers : {'Authorization' : `Bearer ${this.token}`},
				url:this.apiUrl+'/binary/schedule/upload',
				data: formData,
				method: 'POST'
			})
			.then(response => {
				setTimeout(() => {
					this.spinner = false
					this.importfile = false
				},500)
			}).catch((error) => {
				console.log(error.response)
			})
		},
		handleFileUpload(){
			this.file = this.$refs.file.files[0];
		},
        displaySchedule: function() {
			//this.spinner  = true
			axios.create({
				baseURL: this.apiUrl,
				headers: {
					'Authorization': `Bearer ${this.token}`
				}})
			.get(`/binary/schedule/display/${this.month}/${this.cutoff}/${this.department.id}`)
			.then((res) => {
				this.rangeHeader = res.data.ranges
				this.schdules = res.data.members
				//this.initData = res.data.members
				//this.spinner  = false
			})
		},
		filterByDate:function(){
			this.displaySchedule()
		},
        getDropdownProperties: function() {
			axios.create({
				baseURL: this.apiUrl,
				headers: { 'Authorization': `Bearer ${this.token}` }
			}).get('/employee/dropdown/properties')
			.then((res) => {
				this.departments = res.data.data.department
			});
		},
		getTemplate: function() {
			axios.create({
				baseURL: this.apiUrl,
				headers: {
					'Authorization': `Bearer ${this.token}`
				}})
			.get('/employee/template/download')
			.then((res) => {
				this.downloadTemplate(res.data.data.binary_template)
			})
		},
		downloadTemplate:function(url){
			axios({
				url: this.apiUrl+'/'+url,
				method: 'GET',
				responseType: 'arraybuffer',
			}).then((response) => {
				var fileURL = window.URL.createObjectURL(new Blob([response.data]));
				var fileLink = document.createElement('a');
				fileLink.href = fileURL;
				fileLink.setAttribute('download', 'Binary_Schedule_Template.csv');
				document.body.appendChild(fileLink);
				fileLink.click();
			});
		},
	}
}
</script>
